import { fmtDate, statusBadge, getNewsTime } from '../calendarUtils';

function DailyView({
  currentDay, newsMap, todayStr, previewMap,
  openPostDetail, openDatePosts,
}) {
  const dateStr = fmtDate(currentDay);
  const dayNews = newsMap[dateStr] || [];
  const isToday = dateStr === todayStr;
  const previewCount = previewMap ? (previewMap[dateStr] || 0) : 0;

  return (
    <div className="border border-slate-200 dark:border-slate-800 rounded-xl overflow-hidden">
      {/* 일간 헤더 요약 */}
      <div className={`px-3 sm:px-5 py-3 sm:py-4 bg-slate-50 dark:bg-slate-800/50 border-b border-slate-200 dark:border-slate-700 flex items-center justify-between ${isToday ? 'border-l-4 border-l-primary' : ''}`}>
        <div className="flex items-center gap-2 sm:gap-3">
          <span className="text-xl sm:text-2xl font-bold dark:text-white">{currentDay.getDate()}</span>
          <div>
            <p className="text-xs sm:text-sm font-semibold dark:text-slate-200">{currentDay.getFullYear()}년 {currentDay.getMonth() + 1}월</p>
            <p className="text-[10px] sm:text-xs text-slate-500">{isToday ? '오늘' : ['일요일','월요일','화요일','수요일','목요일','금요일','토요일'][currentDay.getDay()]}</p>
          </div>
        </div>
        <div className="flex items-center gap-2 sm:gap-3">
          <span className="text-xs sm:text-sm font-semibold dark:text-slate-300">{dayNews.length}건</span>
          {dateStr >= todayStr && (
            <button onClick={() => openDatePosts(dateStr, dayNews)}
              className="px-2.5 sm:px-3 py-1.5 text-xs font-semibold text-white bg-primary rounded-lg hover:bg-primary/90 transition-colors flex items-center gap-1">
              <span className="material-symbols-outlined text-sm">add</span><span className="hidden sm:inline">추가</span>
            </button>
          )}
        </div>
      </div>

      {previewCount > 0 && (
        <div className="px-5 py-3 bg-primary/5 dark:bg-primary/10 border-b border-primary/20">
          <span className="text-xs text-primary font-bold">{previewCount}개 생성 예정</span>
        </div>
      )}

      {/* 게시물 리스트 */}
      {dayNews.length > 0 ? (
        <div className="divide-y divide-slate-100 dark:divide-slate-800">
          {dayNews.map(news => {
            const badge = statusBadge(news.uploadStatus);
            const time = getNewsTime(news);
            return (
              <div key={news.id} onClick={() => openPostDetail(news)}
                className="flex items-center gap-4 px-5 py-4 hover:bg-slate-50 dark:hover:bg-slate-800/50 cursor-pointer transition-colors">
                {news.imageUrl ? (
                  <div className="shrink-0 size-20 rounded-lg overflow-hidden border border-slate-200 dark:border-slate-700 relative">
                    <img src={news.imageUrl} alt="" className="w-full h-full object-cover" onError={(e) => { e.target.style.display = 'none'; }} />
                    {news.media?.length > 1 && (
                      <span className="absolute bottom-1 right-1 px-1.5 py-0.5 bg-black/60 text-white text-[9px] font-bold rounded flex items-center gap-0.5">
                        <span className="material-symbols-outlined" style={{ fontSize: '10px' }}>photo_library</span>
                        {news.media.length}
                      </span>
                    )}
                  </div>
                ) : (
                  <div className="shrink-0 size-20 rounded-lg bg-slate-100 dark:bg-slate-800 flex items-center justify-center">
                    <span className="material-symbols-outlined text-slate-300 dark:text-slate-600 text-2xl">image</span>
                  </div>
                )}
                <div className="flex-1 min-w-0">
                  <p className="text-sm font-semibold dark:text-white line-clamp-1">{news.title || '제목 없음'}</p>
                  <p className="text-xs text-slate-500 dark:text-slate-400 line-clamp-2 mt-1">{news.description || news.caption || ''}</p>
                  <div className="flex items-center gap-3 mt-2">
                    <span className={`px-2 py-0.5 rounded text-[10px] font-bold ${badge.bg} ${badge.text} border ${badge.border}`}>{badge.label}</span>
                    {time && (
                      <span className="text-[11px] text-slate-400 flex items-center gap-1">
                        <span className="material-symbols-outlined text-xs">schedule</span>{time}
                      </span>
                    )}
                    {news.imageSource && (
                      <span className="text-[10px] text-slate-400 bg-slate-100 dark:bg-slate-800 px-1.5 py-0.5 rounded">{news.imageSource}</span>
                    )}
                  </div>
                </div>
                <span className="material-symbols-outlined text-slate-300 dark:text-slate-600">chevron_right</span>
              </div>
            );
          })}
        </div>
      ) : (
        <div className="py-16 text-center">
          <span className="material-symbols-outlined text-5xl text-slate-200 dark:text-slate-700">event_busy</span>
          <p className="mt-3 text-sm text-slate-400 dark:text-slate-500">이 날짜에 게시물이 없습니다</p>
          {dateStr >= todayStr && (
            <button onClick={() => openDatePosts(dateStr, [])}
              className="mt-4 px-4 py-2 text-xs font-semibold text-primary border border-primary/30 rounded-lg hover:bg-primary/10 transition-colors">
              게시물 추가하기
            </button>
          )}
        </div>
      )}
    </div>
  );
}

export default DailyView;
